import {useCallback, useEffect} from 'react';
import {toast} from 'react-toastify';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {useSignOut} from 'api/generated';
import {usePersistentStore} from 'stores';
import {Spinner, Transitioner} from 'components';

interface IImpersonateProps {}

const Impersonate = ({}: IImpersonateProps) => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';

  const authToken = usePersistentStore(s => s.authToken);
  const setAuthToken = usePersistentStore(s => s.setAuthToken);
  const setImpersonating = usePersistentStore(s => s.setImpersonating);
  const resetStore = usePersistentStore(s => s.reset);

  const navigate = useNavigate();

  const signOut = useSignOut();
  const handleSignOut = useCallback(async () => {
    const {data: res} = await signOut.mutateAsync();
    if (res.data?.success) {
      resetStore();
    } else if (res.errors) {
      toast.error(res.errors[0].detail);
    }
  }, []);

  useEffect(() => {
    if (!token) {
      return;
    }
    (async () => {
      if (authToken) {
        await handleSignOut();
      }
      setAuthToken(token);
      setImpersonating(true);
      navigate('/', {replace: true});
    })();
  }, [token, authToken, handleSignOut, navigate]);

  if (!token) {
    return (
      <section className="flex flex-col flex-1 p-6 lg:px-8">
        <Transitioner>
          <div className="sm:mx-auto sm:w-full sm:max-w-2xl">
            <h1 className="text-center text-2xl/9 font-bold dark:text-white">Account Impersonation</h1>
            <p className="text-center text-red-500 mt-5">Token not found</p>
          </div>
        </Transitioner>
      </section>
    );
  }

  return (
    <section className="flex flex-col flex-1 p-6 lg:px-8">
      <Transitioner classNames="flex justify-center py-14">
        <Spinner />
      </Transitioner>
    </section>
  );
};

export default Impersonate;
